import { inject, Injectable } from '@angular/core';

import type { Firm } from './models';

import { PermissionService } from '@core/auth';

@Injectable({ providedIn: 'root' })
export class FirmPolicy {
  private readonly permissions = inject(PermissionService);

  public canEdit(_firm: Firm): boolean {
    return this.permissions.has('edit_firms');
  }

  public canDelete(_firm: Firm): boolean {
    return this.permissions.has('delete_firms');
  }
}
